import { render } from "./NoContentPage.vue?vue&type=template&id=2ac09cd1&scoped=true"
import script from "./NoContentPage.vue?vue&type=script&lang=js"
export * from "./NoContentPage.vue?vue&type=script&lang=js"

import "./NoContentPage.vue?vue&type=style&index=0&id=2ac09cd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac09cd1"]])

export default __exports__